module.exports = __webpack_public_path__ + "img/logo.5c33e6cd.png";